var map = {
	"./google_ads.webp": "2072",
	"./google_analytics.webp": "f7ec",
	"./gtm.webp": "8cf9",
	"./internet.webp": "8aa5",
	"./magento.webp": "50f0",
	"./prestashop.webp": "1d20",
	"./shopify.webp": "8053",
	"./wordpress.webp": "b9f6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1506";